import React from "react";

export function MessageSvgIcon(
    props: React.SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width={512}
            height={512}
            {...props}
        >
            <path d="M256.002 182.774c-12.718 0-21.761 5.37-21.761 13.283V303.73c0 6.782 9.044 13.565 21.761 13.565 12.152 0 22.043-6.783 22.043-13.565V196.057c0-7.913-9.891-13.283-22.043-13.283zM256.002 116.361c-13 0-23.174 9.326-23.174 20.065s10.174 20.348 23.174 20.348c12.718 0 22.892-9.609 22.892-20.348 0-10.738-10.175-20.065-22.892-20.065z" />
            <path d="M256 0C134.398 0 36 98.348 36 219.873c0 99.231 65.333 181.626 153.417 209.609l50.032 73.747a20 20 0 0 0 33.102 0l50.032-73.747C410.706 401.486 476 319.061 476 219.873 476 98.271 377.523 0 256 0zm48.645 393.099a20.003 20.003 0 0 0-11.165 8.033L256 456.376l-37.479-55.243a20.004 20.004 0 0 0-11.166-8.033C132.377 372.135 76 303.181 76 219.873 76 120.69 156.748 40 256 40s180 80.69 180 179.873c0 83.391-56.46 152.285-131.355 173.226z" />
        </svg>
    );
}
